import React, { useEffect, useRef, useState } from 'react';
import { Input, User } from '@nextui-org/react';
import { IconMessageCircleSearch, IconSend } from '@tabler/icons-react';
import { classNames, fromPhotos, SocketEvents } from '../../../utils';
import { useSelector } from 'react-redux';
import { TeacherChatService } from '../../../services';
import { useSocket } from '../../../context/socket';
import moment from 'moment';

export const Chat = ({ chatSelected }) => {
  const user = useSelector((state) => state.user);
  const [message, setMessage] = useState('');
  const [chatMessages, setChatMessages] = useState([]);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const socket = useSocket();
  const messagesEndRef = useRef(null);


  const handleSendMessage = async () => {
    if (message.trim()) {
      setMessage('');
      const response = await TeacherChatService.chat.send({
        chat_id: chatSelected?.chat_id,
        user_id: user.id,
        professor_id: user.id,
        parent_id: chatSelected?.user?.id,
        message,
      });
      setCurrentChatId(response?.data?.chat?.id);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const getChats = async () => {
    const response = await TeacherChatService.chat.viewChats({ user_id: user.id, chat_id: chatSelected?.chat_id });
    setChatMessages(response.messages);
  }

  useEffect(() => {
    getChats()
    setCurrentChatId(chatSelected?.chat_id);
    setCurrentUser(chatSelected?.user);
  }, [chatSelected])

  useEffect(() => {
    if (!socket) return;
    const handleIncomingMessage = (newMessage) => {
      if (newMessage.chat?.id === currentChatId) {
        setChatMessages((prev) => [...prev, newMessage]);
      }
    };

    socket.on(SocketEvents.CHAT.MESSAGE, handleIncomingMessage);

    return () => {
      socket.off(SocketEvents.CHAT.MESSAGE, handleIncomingMessage);
    };
  }, [socket, currentChatId]);

  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);



  if (!chatSelected) {
    return (
      <div className="flex-1 bg-white flex flex-col text-gray items-center justify-center">
        <IconMessageCircleSearch className="text-gray-500" size={70} />
        <p>Selecciona un chat para visualizar</p>
      </div>
    )
  }




  return (
    <div className="flex-1 bg-white flex flex-col translate-x-0">
      <div className='w-full flex items-center p-4 bg-primary fixed top-0 left-0 z-10 h-20'>
        <User
          key={currentUser?.photo}
          name={`${currentUser?.name} ${currentUser?.lastname}`}
          avatarProps={{ showFallback: true, radius: 'full', src: user?.photo ? fromPhotos(currentUser?.photo) : null }}
          classNames={{ name: 'text-white capitalize font-bold' }}
        />
      </div>

      <div className="flex-1 overflow-y-auto space-y-4 p-4 mt-20">
        {chatMessages.map((msg) => (
          <div
            key={msg.id}
            className={classNames(
              'flex justify-start',
              msg?.user_id === user.id ? 'justify-end' : 'justify-start'
            )}
          >
            <div
              className={classNames(
                'max-w-xs min-w-[10rem] p-3 rounded-lg flex flex-col',
                msg?.user_id === user.id ? 'bg-primary/25' : 'bg-green/25'
              )}

            >
              <p>{msg.message}</p>
              <p className='text-xs font-light ml-auto'>{moment(msg.created_at).format('DD/MM/YYYY hh:mm a')}</p>
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <div className='bg-primary p-5'>
        <div className="flex items-center space-x-2">
          <Input
            clearable
            underlined
            placeholder="Escribe un mensaje..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            className="flex-1"
          />

          <IconSend
            size={30}
            color="white"
            onClick={handleSendMessage}
            className="cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
};
